export default __webpack_public_path__ + "static/nhmla-c88f02dd6bf496a502da42b0e58f00b1.mp4";